<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <template v-for="item in routes">
          <router-link 
            :key="item.path"
            v-if="hasVisibleChildren(item)"
            tag="li" 
            class="nav-item nav-dropdown" 
            :to="item.path + '/' + item.children[0].path"
            :class="{'active': isParentActive(item)}">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick">
              <Icon :type="item.icon" color="white"/>
              {{ item.name }}
            </div>
            <ul class="nav-dropdown-items">
              <li class="nav-item" 
                v-for="child in getVisibleChildren(item)" 
                :key="child.path"
                @click="addActive">
                <router-link 
                  v-if="child.children" 
                  :to="item.path + '/' + child.path + '/' + child.children[0].path" 
                  class="nav-link"
                  active-class="active">
                  <Icon :type="child.icon" color="white"/>
                  {{ child.name }}
                </router-link>
                <router-link 
                  v-else 
                  :to="item.path + '/' + child.path" 
                  class="nav-link"
                  active-class="active">
                  <Icon :type="child.icon" color="white"/>
                  {{ child.name }}
                </router-link>
              </li>
            </ul>
          </router-link>

          <li :key="item.path" class="nav-item" v-if="!item.hidden && !item.children">
            <router-link 
              :to="item.path" 
              class="nav-link" 
              active-class="active" 
              exact>
              <Icon :type="item.icon" color="white"/>
              {{ item.name }}
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    addActive(e) {
      e.preventDefault()
      e.target.parentElement.parentElement.parentElement.classList.add('open')
    },
    hasVisibleChildren(item) {
      return !item.hidden && item.children && item.children.length > 0
    },
    getVisibleChildren(item) {
      return item.children ? item.children.filter(child => !child.hidden) : []
    },
    isParentActive(item) {
      if (!item.children) return false
      const currentPath = this.$route.path
      return item.children.some(child => {
        if (child.children) {
          return currentPath.startsWith(item.path + '/' + child.path)
        }
        return currentPath === item.path + '/' + child.path
      })
    }
  },
  mounted(){
    console.log(this.routes)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wscn-icon {
  margin-right: 10px;
}

.hideSidebar .menu-indent {
  display: block;
  text-indent: 10px;
}

.sidebar {
  background-color: #1584e9;
  
  .nav-item {
    .nav-link {
      color: #fff;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }

      &.active {
        background-color: white !important;
        color: #293033 !important;
      }
    }
  }

  .nav-dropdown {
    &.open {
      > .nav-link {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    &.active {
      > .nav-link {
        background-color: white !important;
        color: #293033 !important;
      }
    }
  }
}
</style>
